import {cdnImage} from '@/util/cdnImage';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
const test = cdnImage('career/feat-right.webp');
import DisplayImage from '@/components/Ui-components/display-image';
import SimpleAccordion from '@/components/MUI-Components/MUI-Accordian';

const cultureStackData = [
    {
        question: '1. Welcome Change',
        answer: 'The comfort zone is boring. The edge of the envelope is exciting. We don’t want you to be shortchanged. We want you to cheer and even lead revolutions. We want those who embrace change.'
    },
    {
        question: '2. Enjoy freedom',
        answer: 'If you like being accountable and being able to make decisions, you’ll like working with us. It’s not a farm for sheep to flock. It’s an open and level playing field free from bureaucracy and hierarchy.'
    },
    {
        question: '3. Celebrate Performance',
        answer: 'Results matter. What we want to achieve is far more than what is expected from us. This means more than merely having best-in-class standards but consistently raising the bar. Aim high, and do better.'
    },
    {
        question: '4. Own your discipline',
        answer: 'You are not a brick in the wall. Nor are you a cog in the wheel. You are either the wall or the wheel. You are either a problem or the solution. We prefer discipline that comes from within. Be yourself.'
    },
    {
        question: '5. Open management',
        answer: 'We don’t want yes men nor do we want petty tyrants. We want you to make breakthroughs. In a meritocracy, you don’t wield power; you earn respect because you deserve it.'
    },
    {
        question: '6. Total transparency',
        answer: 'There are no hidden agendas. There are no ifs, buts or fine print clauses when it comes to work. Good work is expected, great work encouraged and epic work applauded.'
    }
];

const WorkCulture = () => {
    return (
        <MUIBox className="work-culture-main">
            <MUIBox className="spectrum-header-wrapper solutions top-space">
                <MUITypography className="spectrum-heading color-black ">#WorkCulture@Debut</MUITypography>
                <MUITypography className="span-text ">
                    <span>“We rise by lifting others”</span>
                </MUITypography>

                <MUIBox className="divder-wrapper">
                    <hr className="divider-line" />
                </MUIBox>
                <MUIBox className="sub-heading-box text-padding">
                    <MUITypography className="spectrum-sub-heading color-black">
                        Opportunities and talent: it’s a great combination. It produces great results. Work culture at Debut Infotech isn’t
                        a set of precise rules but a collection of precious values.
                    </MUITypography>
                </MUIBox>
            </MUIBox>
            <MUIBox className="work-culture-stack">
                <MUIGrid container spacing={3}>
                    <MUIGrid item xs={12} sm={12} md={5} lg={6}>
                        <MUIBox className="work-culture-box">
                            <MUIGrid container spacing={2} paddingTop={3} paddingX={1}>
                                <SimpleAccordion
                                    accordianData={cultureStackData}
                                    className="work-culture-box-inner"
                                    accheadClassName="accordion-inner"
                                    isIconVisible={false}
                                    removeIconClass="remove-icon-color-change"
                                />
                            </MUIGrid>
                        </MUIBox>
                    </MUIGrid>
                    <MUIGrid item xs={12} sm={12} md={7} lg={6} className="work-cluture-right-img">
                        <MUIBox className="work-cluture-right-img-inner">
                            <DisplayImage src={test} alt="test" />
                        </MUIBox>
                    </MUIGrid>
                </MUIGrid>
            </MUIBox>
        </MUIBox>
    );
};

export default memo(WorkCulture);
